import { render, staticRenderFns } from "./ProductStockList.vue?vue&type=template&id=65427f18&scoped=true&"
import script from "./ProductStockList.vue?vue&type=script&lang=js&"
export * from "./ProductStockList.vue?vue&type=script&lang=js&"
import style0 from "./ProductStockList.vue?vue&type=style&index=0&id=65427f18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65427f18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65427f18')) {
      api.createRecord('65427f18', component.options)
    } else {
      api.reload('65427f18', component.options)
    }
    module.hot.accept("./ProductStockList.vue?vue&type=template&id=65427f18&scoped=true&", function () {
      api.rerender('65427f18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/basic/stock/ProductStockList.vue"
export default component.exports